/*
 * Shared PLP controller: filter/sort disclosure panels + Load more.
 * Drives every .collection-plp section on the page (collection AND search).
 * No-ops when no such section exists.
 */
  (function () {
  function init() {
    var sections = document.querySelectorAll('.collection-plp');

    // Infinite scroll appends pages client-side — never keep ?page=2+ in the URL.
    var loc = new URL(window.location.href);
    var stalePage = parseInt(loc.searchParams.get('page'), 10);
    if (stalePage > 1) {
      var hasLoadMore = false;
      sections.forEach(function (section) {
        if (section.querySelector('[data-collection-load-more]')) hasLoadMore = true;
      });
      if (hasLoadMore) {
        loc.searchParams.delete('page');
        window.location.replace(loc.pathname + loc.search + loc.hash);
        return;
      }
    }

    sections.forEach(function (section) {
      var filterToggle  = section.querySelector('[data-collection-filter-toggle]');
      var filterPanel   = section.querySelector('[data-collection-filter-panel]');
      var sortWrapper   = section.querySelector('[data-collection-sort]');
      var sortToggle    = section.querySelector('[data-collection-sort-toggle]');
      var sortPanel     = sortWrapper && sortWrapper.querySelector('.collection-plp__sort-panel');
      var sortHidden    = section.querySelector('[data-collection-sort-hidden]');
      var loadMore      = section.querySelector('[data-collection-load-more]');
      var grid          = section.querySelector('[data-collection-grid]');
      var pagination    = section.querySelector('[data-collection-pagination]');

      // ── Helpers ─────────────────────────────────────────────────────────────
      function openPanel(panel, toggle) {
        panel.setAttribute('data-open', 'true');
        toggle && toggle.setAttribute('aria-expanded', 'true');
      }

      function closePanel(panel, toggle) {
        panel.removeAttribute('data-open');
        toggle && toggle.setAttribute('aria-expanded', 'false');
      }

      function isPanelOpen(panel) {
        return panel.getAttribute('data-open') === 'true';
      }

      function closeSortPanel() {
        sortToggle && sortToggle.setAttribute('aria-expanded', 'false');
        sortPanel.setAttribute('data-open', 'closing');
        sortPanel.addEventListener('animationend', function () {
          if (sortPanel.getAttribute('data-open') === 'closing') {
            sortPanel.removeAttribute('data-open');
          }
        }, { once: true });
      }

      // ── Filter toggle ────────────────────────────────────────────────────────
      if (filterToggle && filterPanel) {
        filterToggle.addEventListener('click', function () {
          if (isPanelOpen(filterPanel)) {
            closePanel(filterPanel, filterToggle);
            // also close sort if open
            if (sortPanel && isPanelOpen(sortPanel)) closeSortPanel();
          } else {
            openPanel(filterPanel, filterToggle);
            if (sortPanel && isPanelOpen(sortPanel)) closeSortPanel();
          }
        });

        // Close on click outside
        document.addEventListener('click', function (e) {
          if (isPanelOpen(filterPanel) && !section.contains(e.target)) {
            closePanel(filterPanel, filterToggle);
          }
        });
      }

      // ── Sort toggle & option selection ───────────────────────────────────────
      if (sortToggle && sortPanel) {
        sortToggle.addEventListener('click', function () {
          if (isPanelOpen(sortPanel)) {
            closeSortPanel();
          } else {
            openPanel(sortPanel, sortToggle);
            if (filterPanel && isPanelOpen(filterPanel)) closePanel(filterPanel, filterToggle);
          }
        });

        // Close sort panel on click outside
        document.addEventListener('click', function (e) {
          if (isPanelOpen(sortPanel) && !sortWrapper.contains(e.target)) {
            closeSortPanel();
          }
        });

        // Sort option click: update URL sort_by param without touching filter params
        sortPanel.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-sort-value]');
          if (!btn) return;

          var sortValue = btn.getAttribute('data-sort-value');
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortValue);
          // Remove stale page param so we always land on page 1
          url.searchParams.delete('page');

          // Sync the hidden input so in-flight filter submissions preserve this sort
          if (sortHidden) sortHidden.value = sortValue;

          closeSortPanel();
          window.location.href = url.toString();
        });
      }

      // ── Load more with promo-offset buffer ───────────────────────────────────
      // Page 1 shows fewer products because promos claim grid cells. The products
      // that didn't fit are emitted into <template data-collection-buffer>. We hold
      // them in `buffer` and, on each click, prepend them to a chunk of the next
      // server page so every click reveals a full `chunkSize` batch with no skips.
      var chunkSize  = parseInt(grid && grid.getAttribute('data-collection-chunk'), 10) || 0;
      var totalCount = parseInt(grid && grid.getAttribute('data-collection-total'), 10) || 0;
      var infiniteScrollObserver = null;

      var buffer = [];
      var bufferTpl = section.querySelector('[data-collection-buffer]');
      if (bufferTpl && bufferTpl.content) {
        buffer = Array.prototype.slice.call(bufferTpl.content.querySelectorAll('.collection-plp__card'));
        bufferTpl.remove();
      }

      function countDisplayed() {
        var g = section.querySelector('[data-collection-grid]');
        return g ? g.querySelectorAll('.collection-plp__card').length : 0;
      }

      function updateProgress() {
        var shown = countDisplayed();
        var countEl = section.querySelector('[data-collection-count]');
        if (countEl) {
          // Replace just the leading "visible" number, preserving localized markup.
          countEl.innerHTML = countEl.innerHTML.replace(/\d+/, String(shown));
        }
        var thumb = section.querySelector('[data-collection-progress]');
        if (thumb && totalCount > 0) {
          thumb.style.width = Math.min(100, (shown / totalCount) * 100) + '%';
        }
      }

      function removeLoadMore() {
        var b = section.querySelector('[data-collection-load-more]');
        if (b) b.remove();
        if (infiniteScrollObserver) {
          infiniteScrollObserver.disconnect();
          infiniteScrollObserver = null;
        }
      }

      section.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-collection-load-more]');
        if (!btn) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();

        var gridNow = section.querySelector('[data-collection-grid]');
        if (!gridNow) return;

        var bufferOnly = btn.hasAttribute('data-buffer-only');
        var nextUrl = bufferOnly ? null : btn.getAttribute('href');

        // No server page left — just flush whatever is still buffered.
        if (!nextUrl) {
          buffer.forEach(function (node) { gridNow.appendChild(node); });
          buffer = [];
          gridNow.removeAttribute('data-has-buffer');
          removeLoadMore();
          updateProgress();
          return;
        }

        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');

        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            btn.setAttribute('aria-busy', 'false');
            btn.classList.remove('is-loading');

            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-collection-grid]');
            var newLoadMore = doc.querySelector('[data-collection-load-more]');
            var fetchedNextUrl = newLoadMore ? newLoadMore.getAttribute('href') : null;
            var fetchedHasNext = !!(fetchedNextUrl && fetchedNextUrl !== '#');

            var cards = newGrid
              ? Array.prototype.slice.call(newGrid.querySelectorAll('.collection-plp__card'))
              : [];

            var toAppend;
            if (fetchedHasNext) {
              // Keep a queue of pending cards (overflow from page 1 + newly fetched).
              // Each click should append exactly `chunkSize` cards, no matter how
              // many are currently sitting in `buffer`.
              var queue = buffer.concat(cards);
              toAppend = queue.slice(0, chunkSize);
              buffer = queue.slice(chunkSize);
            } else {
              // Last server page: reveal everything still pending, hold nothing back.
              toAppend = buffer.concat(cards);
              buffer = [];
            }

            toAppend.forEach(function (node) { gridNow.appendChild(node); });

            if (buffer.length === 0) {
              gridNow.removeAttribute('data-has-buffer');
            }

            if (fetchedHasNext) {
              btn.setAttribute('href', fetchedNextUrl);
              btn.removeAttribute('data-buffer-only');
            } else if (buffer.length > 0) {
              btn.setAttribute('href', '#');
              btn.setAttribute('data-buffer-only', 'true');
            } else {
              removeLoadMore();
            }

            updateProgress();
          })
          .catch(function () {
            window.location.href = nextUrl;
          });
      });

      // Infinite scroll: auto-trigger load more when pagination comes into view.
      // Products load ~400px before the user reaches the bottom.
      if (pagination && loadMore) {
        infiniteScrollObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var btn = section.querySelector('[data-collection-load-more]');
            if (btn && !btn.classList.contains('is-loading')) {
              btn.click();
            }
          });
        }, { rootMargin: '0px 0px 400px 0px' });
        infiniteScrollObserver.observe(pagination);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  })();
